import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavbar from '../components/TopNavBar';

const MainLayout = () => {  
  return (
    <div className="main-layout">
      <TopNavbar/>
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
